import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const customReturnSettings = defineIntegrationSettings({
  fields: {},
  secrets: {},
  connectOnly: {},
  computed: { enabled: z.boolean() },
});
